export const doNothing = () => { };

export const haveCanManageWorkspacesRight = (companyRole) => (["ALL_WORKSPACES", "OWNED_BY_THE_USER"].includes(companyRole?.companyRoleRights?.canManageWorkspaces));

export const modalType = Object.freeze({
  CREATE_MODAL: "create-modal",
  EDIT_MODAL: "edit-modal",
  NONE: "none",
});

export const initialState = {
  activeModal: modalType.NONE,
  dataReady: false,
  haveErrors: false,
};
